export const version = '22.01.01'


export const BACKEND_URL_PREFIX = 'https://monitor.lms2.edumil.ru/api'